import type { ReactNode } from 'react';
import type { PhotoView, VideoConfig, GalleryUsageData } from 'types';
import { useAdDetailsContext } from 'contexts/AdDetailsContext';
import { useUserContext } from 'contexts/UserContext';
import { GalleryOnPage } from 'components/Toolkit/Gallery/GalleryOnPage';
import { pushToDataLayer } from 'services/gtmService';

export interface RevealGalleryProps {
  photo?: PhotoView;
  photos?: PhotoView[];
  link360?: string;
  link360Interior?: string;
  videoConfig?: VideoConfig;
  title: string;
  renderSendMessage?: ReactNode;
  renderShowPhone?: ReactNode;
  renderShareAd?: ReactNode;
  renderSaveAd?: ReactNode;
  keyInfo?: (string | undefined | ReactNode)[];
  currency: 'EUR' | 'GBP';
  price: string | null;
  oldPrice?: string;
  pricePerMonth?: string;
  mediaCount: number;
  renderDfpUnit?: ReactNode;
  youTubeVideoId?: string;
  youTubeReviewVideoId?: string;
  isDealer: boolean;
  trackingId?: string;
  className?: string;
  isGalleryOpen: boolean;
  setIsGalleryOpen: (value: boolean) => void;
  isYoutubeReviewOpen?: boolean;
  setIsYoutubeReviewOpen?: (value: boolean) => void;
  cdnUrl: string;
  imageCounterForDFP?: number;
  setImageCounterForDFP?: (value: number) => void;
  isPreview?: boolean;
  refreshTopAndSideDFPUnit?: () => void;
}

function RevealGallery({ ...rest }: RevealGalleryProps) {
  const { isSendMessageModalOpen } = useAdDetailsContext();
  const { isSignUpModalOpen, isLoginModalOpen } = useUserContext();

  function trackGalleryUsage(usageEvent: GalleryUsageData) {
    const { event, data } = usageEvent;

    if (event === 'CLOSE') {
      pushToDataLayer({
        event: 'gallery_close',
        ...data,
      });
    }

    if (event === 'OPEN') {
      pushToDataLayer({ event: 'lightbox_open' });
    }
  }

  return (
    <GalleryOnPage
      reportOnGalleryUsage={trackGalleryUsage}
      disableKeyEventListeners={
        isSignUpModalOpen || isLoginModalOpen || isSendMessageModalOpen
      }
      {...rest}
    />
  );
}

export { RevealGallery };
